import push from "./push";

/**
 * Sends a `initiateCheckout` event for Google Tag Manager
 * https://developers.google.com/tag-manager/devguide#multipush
 */
export default function pushInitiateCheckout(
    sessionId: string | null,
    leadSku: string | null,
    promotionPrice: number,
    promotionCode: string
): Promise<void> {
    return push("initiateCheckout", {
        "session-id": sessionId, //This unique id will be used to dedupe Facebook pixel/s2s records
        "lead-sku": leadSku, //The SKU of the first (by sort order) promotion item
        "promotion-price": promotionPrice, //The calculated price of all promotion items plus their shipping costs
        "promotioncode": promotionCode // The promotion code
    });
}
